module.exports = __webpack_public_path__ + "catalog/items/outdoor/Bench/Bench.svg";